import styled from '@emotion/styled'

import { Color } from '../../enums/color'
import { DefaultValue } from '../../enums/defaultValue'
import { Spacing } from '../../enums/spacing'
import { getShadow } from '../../utils/getShadow'

interface NavWrapperProps {
  visible?: boolean
  width?: number
  isInverted?: boolean
}

export const NavWrapper = styled.div<NavWrapperProps>`
  display: flex;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  flex-direction: column;
  width: 100%;
  padding: ${Spacing.S8};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  ${getShadow('raisedStrong')};

  ${({ isInverted }) =>
    isInverted &&
    `
    background-color: ${Color.Green950};
    box-shadow: 0 6px 16px 0 ${Color.Black};

    /* Counters the app's dark-mode invert filter applied to this panel's portal root, so the advisor green is preserved.
    Direct copy of FILTER_ACCENT_INVERSION but isolated for the DS here */
    .theme-layout-dark & {
      filter: invert(100%) hue-rotate(180deg) saturate(0.5);
    }
  `}
`

export const NavFooter = styled.footer`
  margin-top: auto;
`

export const NavHeader = styled.header`
  margin-bottom: ${Spacing.S8};
`
